import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ReactQueryKeys } from 'enums';
import { isApprovalHold } from 'modules/settings/pages/approvals/is-approval-hold';

export const useWithdrawal = (): UseMutationResult<any, any, any> => {
  const queryClient = useQueryClient();

  const { treasureApi } = useTreasureApi(ApiKeys.PortalGateway);

  const postWithdrawal = async ({
    amount,
    bankAccountId,
    idempotencyKey,
  }: {
    amount: number;
    bankAccountId: string;
    idempotencyKey: string;
  }) => {
    const response = await treasureApi().post('/withdrawal/create_withdrawal', {
      amount: amount * 100, // api expects the amount to be in cents
      bankAccountId,
      idempotencyKey,
    });

    if (isApprovalHold(response.data)) {
      return response.data;
    }

    response.data.amount /= 100; // api returns the amount in cents
    response.data.amountFromCash /= 100; // api returns amountFromCash in cents
    response.data.amountFromManaged /= 100; // api returns amountFromManaged in cents

    return response.data;
  };

  return useMutation(postWithdrawal, {
    onSuccess: () => {
      // TODO: remove old DashboardActivity
      queryClient.invalidateQueries([ReactQueryKeys.DashboardActivity]);
      return queryClient.invalidateQueries([
        ReactQueryKeys.DashboardActivityGateway,
      ]);
    },
  });
};
